/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Changes_Item_4Inputs */

const es_privacy_policy_changes_item_4 = /** @type {(inputs: Privacy_Policy_Changes_Item_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Periodo de 30 dias para revisar antes de que surtan efecto`)
};

const en_privacy_policy_changes_item_4 = /** @type {(inputs: Privacy_Policy_Changes_Item_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30-day period to review before taking effect`)
};

/**
* | output |
* | --- |
* | "30-day period to review before taking effect" |
*
* @param {Privacy_Policy_Changes_Item_4Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_changes_item_4 = /** @type {((inputs?: Privacy_Policy_Changes_Item_4Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Changes_Item_4Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_changes_item_4(inputs)
	return en_privacy_policy_changes_item_4(inputs)
});
export { privacy_policy_changes_item_4 as "privacy_policy.changes.item_4" }